const Platform = require('PSPlatform');
const PSState = require('PSState');
const PSOrientationManager = cc.Class({
    extends: cc.Component,

    statics: {
        LANDSCAPE: 'landscape',
        PORTRAIT: 'portrait'
    },

    properties: {
        aspectRatio: 1,
    },

    onLoad () {
        this.resizeManager = cc.find('ResizeManager').getComponent('ResizeManager');
        this.nodesList = [];

        if (!this.resizeManager) {
            this.node.removeComponent('PSOrientationHandler');
            cc.warn('PSOrientationHandler: no resize manager found');
        }
        if (Platform.isMobile) {
            this.landscapeHandlerFnName = 'onLandscapeMobile';
            this.portaitHandlerFnName = 'onPortraitMobile';
        } else {
            this.landscapeHandlerFnName = 'onLandscapeDesktop';
            this.portaitHandlerFnName = 'onPortraitDesktop';
        }
        this.mode = null;
        PSState.isLandscape = true;
        PSState.isPortait = false;
    },

    start () {

        this.resizeManager.appendNode(this);
    },

    onDestroy() {
        this.resizeManager.removeNode(this);
    },

    onViewResize (_screenRatio, aspectRatio = 1.7) {

        if (this.mode !== PSOrientationManager.PORTRAIT && aspectRatio < this.aspectRatio) {
            this.mode = PSOrientationManager.PORTRAIT;
            this.portraitHandler();
            PSState.isLandscape = false;
            PSState.isPortait = true;

        }
        if (this.mode !== PSOrientationManager.LANDSCAPE && aspectRatio >= this.aspectRatio) {
            this.mode = PSOrientationManager.LANDSCAPE;
            this.landscapeHandler();
            PSState.isLandscape = true;
            PSState.isPortait = false;
        }
    },

    landscapeHandler () {
        this.nodesList.forEach(node => node[this.landscapeHandlerFnName]());
    },
    portraitHandler () {
        this.nodesList.forEach(node => node[this.portaitHandlerFnName]());
    },


    /** adds node to the nodesList. */
    appendNode (node) {
        this.nodesList.push(node);
        if (this.mode === PSOrientationManager.LANDSCAPE) {
            node[this.landscapeHandlerFnName]();
        }
        if (this.mode === PSOrientationManager.PORTRAIT) {
            node[this.portaitHandlerFnName]();
        }
    },

    /** removes node from view resize update */
    removeNode (node) {
        this.nodesList = this.nodesList.filter((value) => {
            return value !== node;
        });
    },
});
